import React from "react";
import DragHandleIcon from "assets/img/homepage/drag-handle-icon.svg";

export function DragHandle(props) {
  const { style, ...rest } = props;
  return (
    <button
      type="button"
      aria-label="drag handle"
      {...rest}
      style={{
        cursor: "grab",
        background: "transparent",
        border: "none",
        padding: 4,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
     <img src={DragHandleIcon} alt="drag handle"/>
    </button>
  );
}